import { Form, Formik, FormikHelpers } from 'formik'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { Button } from '~/components/button'
import { TextInputField } from '~/components/text-input'
import { useRecaptcha } from '~/hooks/use-recaptcha'
import { CenterLayout } from '~/layouts/center-layout'

import IconEmail from './assets/icon-email.svg'
import { useSendPasswordResetEmailMutation } from './graphql/send-password-reset-email'
import { useForm, Values } from './hooks/use-form'
import { useToasts } from '~/context/toasts'

export const ForgotPassword: NextPage = () => {
  const { query } = useRouter()
  const [sendPasswordResetEmail] = useSendPasswordResetEmailMutation()
  const [email, setEmail] = useState<string>()
  const recaptcha = useRecaptcha()
  const toasts = useToasts()

  const prefillEmail = query.email as string | undefined
  const { initialValues, schema } = useForm(prefillEmail)

  if (email) {
    return (
      <CenterLayout
        icon={<IconEmail />}
        heading="Check Your Email"
        subheading="Check your email for instructions to reset your password."
      />
    )
  }

  const handleSubmit = async (
    values: Values,
    helpers: FormikHelpers<Values>
  ) => {
    const { setSubmitting } = helpers
    const recaptchaResponse = await recaptcha.execute()

    try {
      await sendPasswordResetEmail({
        variables: {
          input: {
            email: values.email,
            recaptchaResponse,
          },
        },
      })
      setEmail(values.email)
    } catch (error: any) {
      console.log('error', error)
      toasts.warning('Something went wrong, please try again later.'),

      setSubmitting(false)
      recaptcha.reset()
    }
  }
  return (
    <CenterLayout
      heading={prefillEmail ? 'Set Up Your Password' : 'Reset Your Password'}
      subheading="Enter the email address associated with your account and we'll send you a verification link."
      maxWidth={448}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={schema}
        validateOnBlur={false}
        enableReinitialize
      >
        {({ isSubmitting }) => (
          <Form>
            <TextInputField label="Your Email" name="email" marginBottom={32} />
            <Button type="submit" loading={isSubmitting} width={1}>
              Continue
            </Button>
          </Form>
        )}
      </Formik>
    </CenterLayout>
  )
}
